export default [
  { name: 'United States', value: 'US' },
]
